<template>
  <div class="flex min-h-screen items-center justify-center px-6">
    <StateContainer
      :variant="StateVariant.ERROR"
      :illustration="IllustrationVariant.HTTP_404"
      header="Organization unavailable"
      subheader="This organization has been deactivated. Contact support@exfluential.com if you think this is a mistake."
      primary-cta-label="Sign out"
      @primary-click="signOut"
    />
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router';
import { useErrorStore } from '@/store/use-error-store';
import {
  StateContainer,
  StateVariant,
  IllustrationVariant,
} from '@/views/_components/state-container';

const errorStore = useErrorStore();
const router = useRouter();

const signOut = async () => {
  errorStore.clearError();
  await router.push('/auth/logout');
};
</script>
